import { ArrowRight, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuote } from "@/components/QuoteDialog";
import { company, images } from "@/mock/mock";

export default function CtaBand() {
  const { openQuote } = useQuote();
  return (
    <section className="relative py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative overflow-hidden rounded-3xl border border-white/10">
          <img src={images.network} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-brand-navy/60" />
          <div className="relative px-8 py-16 lg:px-16 lg:py-20">
            <div className="max-w-2xl">
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                Ready to make security your competitive advantage?
              </h2>
              <p className="mt-5 text-lg text-slate-300">
                Book a no-obligation consultation with our Halifax team and get a tailored security roadmap for your organization.
              </p>
              <div className="mt-9 flex flex-wrap items-center gap-4">
                <Button onClick={openQuote} className="group bg-brand-orange hover:bg-brand-orangeDark text-white font-semibold rounded-full px-7 h-12 text-base">
                  Get a Quote
                  <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Button>
                <a href={`tel:${company.phoneHref}`} className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-7 h-12 text-base font-medium text-white hover:bg-white/10 transition-colors">
                  <PhoneCall className="h-5 w-5 text-brand-lime" /> {company.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
